import { Button, Col, Dropdown, message, Modal, Row, Typography } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { FC } from "react";
import { deleteFavoriteList } from "../Services";
import { useQueryClient } from "react-query";
import endpoints from "../EndPoints";
import dayjs from "dayjs";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { ItemType } from "antd/es/menu/interface";

interface FavorListItemHeaderProps {
  item: any;
  setSelectedRecord:any,
  setIsShowEditListModal:any
}

const FavorListItemHeader: FC<FavorListItemHeaderProps> = ({ item,setSelectedRecord,setIsShowEditListModal }) => {
  const { Text } = Typography;
  const queryClient = useQueryClient();

  const confirm = (record: any) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu öğe silinecek. Onaylıyor musunuz?`,
      okText: "Sil",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          await deleteFavoriteList(record);
          openNotificationWithIcon("default", "İşlem Başarılı");
          queryClient.resetQueries({
            queryKey: endpoints.getFavoriteListFilter,
            exact: false,
          });
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };

  const tableItemDropdownMenu = (record: any): ItemType[] => [
    {
      key: "1",
      onClick: async(e) => {
        e.domEvent.stopPropagation(); 
       await  setSelectedRecord(record)
       setIsShowEditListModal(true)
      },
      icon: <EditOutlined />,
      label: "Güncelle",
    },
    {
      key: "2",
      onClick: (e) => {
        e.domEvent.stopPropagation(); 
        confirm(record);
      },
      icon: <DeleteOutlined />,
      label: "Sil",
    },
    {
      key: "3",
      onClick: (e) => {
        e.domEvent.stopPropagation();
  
        const baseUrl = window.location.origin;
        const link = `${baseUrl}/favori/detay/${record.id}`;
        navigator.clipboard.writeText(link).then(() => {
          message.success("Favori listenizin linki kopyalandı");
        }).catch(() => {
          message.error("Link kopyalanırken bir hata oluştu.");
        });
      },
      icon: <ShareAltOutlined />,
      label: "Listeyi Paylaş",
    },
  ];

  return (
    <Col xs={24}>
      <Row>
        <Col xs={12} md={12}>
        <div>
          
          <Text>
            {item.name}
            <span className="!ml-1 !text-xs !text-[#949fa5]">({item?.favorite?.length||0})</span>
          </Text>
        </div>
        <div className="!block lg:!hidden" >
          <Text className="!text-xs !text-[#949fa5]" > {dayjs(item.insertDate).format("DD.MM.YYYY")}</Text>
        </div>
        </Col>
        <Col xs={12} md={12} className="!flex justify-end gap-2 items-center">
          <Text className="!text-xs !text-[#949fa5] !hidden lg:!block">
            {dayjs(item.insertDate).format("DD.MM.YYYY")}
          </Text>
          <Dropdown
            menu={{ items: tableItemDropdownMenu(item) }}
            trigger={["click"]}
          >
            <Button
              type="text"
              className="md:!text-black md:hover:!bg-[#FFC502] md:!bg-transparent md:hover:!text-white !bg-[#FFC502] !text-black  !text-xs !p-2 md:!p-4 md:!text-sm "
              onClick={(e) => e.stopPropagation()} // Dropdown butonuna tıklandığında panel etkilenmez
            >
              İşlemler
            </Button>
          </Dropdown>
        </Col>
      </Row>
    </Col>
  );
};

export default FavorListItemHeader;
